export default __webpack_public_path__ + "assets/images/partner-logos_QdZ_b.png";